import React from 'react';

export const HeroDescription = () => {
  return (
    <div className="mb-4 w-100 text-center" style={{ maxWidth: '454px' }}>
      <p
        className="fw-medium mb-0 d-none d-md-block"
        style={{
          color: '#737373',
          fontSize: '16px'
        }}
      >
        Somos uma alternativa real ao modelo tradicional, conectando pessoas
        a soluções completas: sem burocracia e com impacto. Acreditamos que
        toda vida importa (e que ninguém deve ficar sem acesso ao que é
        essencial para viver melhor).
      </p>
      <p
        className="fw-medium mb-0 d-block d-md-none"
        style={{
          color: '#737373',
          fontSize: '14px',
          lineHeight: '1.25'
        }}
      >
        Somos uma alternativa real ao modelo tradicional, conectando pessoas
        a soluções completas: sem burocracia e com impacto. Acreditamos que
        toda vida importa (e que ninguém deve ficar sem acesso ao que é
        essencial para viver melhor).
      </p>
    </div>
  );
};
